import api from './utilPartner';

const controller = 'Banco';
const url = process.env.VUE_APP_ROOT_API + controller;

export default Object.assign({}, api.GetCrud(controller, null), {
  ListarBancos: function (dto) {
    return api.Axios.GetParams(`${url}/ListarBancos`, dto);
  },
  BuscarBanco: function (dto) {
    return api.Axios.GetParams(`${url}/BuscarBanco`, dto);
  }
});
